import React, { useEffect, useState } from 'react';
import LandingPageView from './LandingPageView';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from 'react-i18next';
import CustomLoading from '../../components/CustomLoading';
import Geocode from 'react-geocode';
import { configuration } from '../../config/main.config';
import { getAddressHome, getAppConfig, isVumaReachPackage, setAddressHome, setPackageInfo, setPackageSeleted, setUTMInfo } from '../../utils/commons';
import { capitalize, sortByPrice, sortByOrderField } from '../../utils/util';

export default function LandingPageController(props) {
    const { t } = useTranslation();

    const [showLoading, setShowLoading] = useState(false);
    const [packages, setPackages] = useState([]);
    const [address, setAddress] = useState(null);
    const [message, setMessage] = useState({});
    const [choosePackage, setChoosePackage] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showTerm, onShowTerm] = useState(false);
    const [addresses, setAddresses] = useState([]);
    const [addressInfor, setAddressInfor] = useState(null);
    const [showListAddresses, setShowListAddresses] = useState(false);
    const [addressSelected, setAddressSelected] = useState(null);
    const [searchType, setSearchType] = useState(0);
    const [ispLocation, setISPLocation] = useState(null);
    const [openserveServices, setOpenserveServices] = useState([]);
    const [openModalBuilding, setOpenModalBuilding] = useState(false)
    const [building, setBuilding] = useState([])
    useEffect(() => {
        onLoadData();
    }, []);

    const onLoadData = async () => {
        setShowLoading(true);
        var url = new URL(window.location.href);
        console.log("url===", url);
        var utm_source = url.searchParams.get("utm_source");
        var utm_campain = url.searchParams.get("utm_campaign");
        if (utm_source && utm_campain) {
            setUTMInfo({
                utm_source: utm_source,
                utm_campain: utm_campain,
            })
        }
        await onLoadProducts();
        setShowLoading(false);
    }

    const onLoadProducts = async () => {
        try {
            let flyLiteFamily = document._portalConfig.flyLiteFamily;
            let flySmartFamily = document._portalConfig.flySmartFamily;
            let flyUltraFamily = document._portalConfig.flyUltraFamily;

            let productFlyLites = [];
            let productFlySmarts = [];
            let productFlyUltras = [];

            var result = await wsclients.lab4services.getProductsV3();
            console.log("result getProducts===", result);
            if (result.code == 'OK') {
                if (result.data) {
                    for (let i = 0; i < result.data.length; i++) {
                        let p = result.data[i];
                        if (p.product && p.product.custom_fields && p.product.custom_fields.length > 0) {
                            p.product.custom_fields.forEach(c => {
                                if (c.key == 'product_price_r') {
                                    p.price_r = parseFloat(c.value);
                                }
                                if (c.key == 'product_price_o') {
                                    p.price_o = parseFloat(c.value);
                                }
                            });
                        }
                        if (p.product_type == "openserve" && document._portalConfig.hideOpenserveProducts)
                            continue;

                        if (p.product_type == "vuma_core" && document._portalConfig.hideVumacoreProducts)
                            continue;

                        if (p.family.toLowerCase() === flyLiteFamily.toLowerCase())
                            productFlyLites.push(p);
                        else if (p.family.toLowerCase() === flySmartFamily.toLowerCase())
                            productFlySmarts.push(p);
                        else if (p.family.toLowerCase() === flyUltraFamily.toLowerCase())
                            productFlyUltras.push(p);
                    }
                }
                console.log("result productFlyLites===", productFlyLites);
                console.log("result productFlySmarts===", productFlySmarts);
                console.log("result productFlyUltras===", productFlyUltras);
                let pkgs = [];
                pkgs.productflylites = productFlyLites.sort(sortByPrice).sort(sortByOrderField);
                pkgs.productflysmarts = productFlySmarts.sort(sortByPrice).sort(sortByOrderField);
                pkgs.productflyultras = productFlyUltras.sort(sortByPrice).sort(sortByOrderField);

                console.log("result pkgs===", pkgs);
                setPackages(pkgs ? pkgs : []);
            }
        }
        catch (ex) {
            console.log("getProducts exception: ", ex);
        }
    }

    const onSelectPackage = async (product) => {
        let packageSelected = {
            ...product,
        };
        if (product && !isVumaReachPackage(product.product_type)) {
            packageSelected.name = product.product && product.product.name ? product.product.name : null;
            packageSelected.id = product.product && product.product.id ? product.product.id : null;
            packageSelected.sku = product.product && product.product.sku ? product.product.sku : null;
        }

        setPackageSeleted(packageSelected);
        props.history.push(paths.package_info);
    }

    const onCheckCoverage = async () => {
        setShowLoading(true);
        setAddressSelected(null);
        resetAvailableProducts();
        let address_info = {};
        try {
            console.log("LandingPageController onCheckCoverage address===", address);
            if (address && address.description) {
                await Geocode.setApiKey(configuration.apiKeyMap);
                var resultAddress = await Geocode.fromAddress(address.description);
                console.log("resultAddress==", resultAddress);
                if (resultAddress.status == 'OK') {
                    if (resultAddress && resultAddress.results.length > 0) {
                        let location = resultAddress.results[0].geometry && resultAddress.results[0].geometry.location ? resultAddress.results[0].geometry.location : null;
                        address_info.latitude = location.lat ? location.lat : null;
                        address_info.longitude = location.lng ? location.lng : null;

                        if (resultAddress.results[0].address_components && resultAddress.results[0].address_components.length > 0) {
                            //city: locality, administrative_area_level_1: state/province, country: country, street_name: route
                            resultAddress.results[0].address_components.forEach(element => {
                                if (element.types.length > 0) {
                                    if (element.types.includes('postal_code')) {
                                        address_info.postal_code = element.long_name;
                                    } else if (element.types.includes('street_number')) {
                                        address_info.street_number = element.long_name;
                                    } else if (element.types.includes('route')) {
                                        address_info.street_name = element.long_name;
                                    } else if (element.types.includes('administrative_area_level_1')) {
                                        address_info.state_province_county = element.long_name;
                                    } else if (element.types.includes('locality')) {
                                        address_info.town_city = element.long_name;
                                    } else if (element.types.includes('sublocality')) {
                                        address_info.suburb = element.long_name;
                                    }
                                }
                            });
                            if (address_info.state_province_county == null || address_info.state_province_county == "") {
                                address_info.state_province_county = address_info.town_city;
                            }
                            if (!address_info.street_number && address.terms && address.terms.length > 0)
                                address_info.street_number = address.terms[0].value
                        }
                    }
                    // address_info.town_city = address_info.state_province_county;
                    console.log("address_info==", address_info);
                    setAddressInfor(address_info);
                    var result = await wsclients.lab4services.onCheckCoverageLatLongV3(address_info);
                    console.log("onCheckCoverrage===", result);
                    if (result.code === 'OK') {
                        let _newAddresses = result.data.addresses ? result.data.addresses : []
                        if (document._portalConfig.hideOpenserveProducts) {
                            _newAddresses = _newAddresses.filter(x => !x.openserve_ref_isp);
                        }
                        setAddresses(_newAddresses);
                        setShowListAddresses(true);
                        /*if (_newAddresses && _newAddresses.length === 1) {
                            // setShowModal(true);
                            setAddressSelected(_newAddresses[0]);
                            setAddressHome({
                                ...address_info,
                                ..._newAddresses[0],
                            });
                            let locationAvaible = await checkLocationAvaibleOrder();
                            if(locationAvaible){
                                setShowModal(true);
                            }
                        } else if (_newAddresses && _newAddresses.length > 1) {
                            setShowListAddresses(true);
                        } else {
                            setMessage({
                                show: true,
                                content: t('address_not_support')
                            });
                        }*/
                    }
                }
            }
        }
        catch (ex) {
            console.log("onCheckCoverrage exception===", ex);
        }
        setShowLoading(false);
    }

    const onCheckCoverageLatLongV3 = async (address_info) => {
        console.log("onCheckCoverageLatLongV3 address_info==", address_info);
        setAddressInfor(address_info);
        var result = await wsclients.lab4services.onCheckCoverageLatLongV3(address_info);
        console.log("onCheckCoverageLatLongV3 onCheckCoverrage===", result);
        if (result.code === 'OK') {
            let _newAddresses = result.data.addresses ? result.data.addresses : []
            if (document._portalConfig.hideOpenserveProducts) {
                _newAddresses = _newAddresses.filter(x => !x.openserve_ref_isp);
            }
            setAddresses(_newAddresses);
            /*if (_newAddresses && _newAddresses.length === 1) {
                // setShowModal(true);
                setAddressSelected(_newAddresses[0]);
                setAddressHome({
                    ...address_info,
                    ..._newAddresses[0],
                });
                let locationAvaible = await checkLocationAvaibleOrder();
                if(locationAvaible){
                    setShowModal(true);
                }
            } else if (_newAddresses && _newAddresses.length > 1) {
                setShowListAddresses(true);
            } else {
                setMessage({
                    show: true,
                    content: t('address_not_support')
                });
            }*/
            return _newAddresses;
        }
    }

    const onCheckCoverageISPLocation = async () => {
        setShowLoading(true);
        let address_info = {
            location_reference: ispLocation,
        };
        try {
            var result = await wsclients.lab4services.onCheckCoverageLatLongV3(address_info);
            console.log("LandingPageController onCheckCoverageISPLocation ===", result);
            if (result.code === 'OK') {
                setAddresses(result.data.addresses ? result.data.addresses : []);
                if (result.data.location) {
                    address_info = {
                        ...address_info,
                        ...result.data.location,
                        street_name: result.data.location && result.data.location.street_name ? capitalize(result.data.location.street_name) : null,
                    }
                }
                console.log('LandingPageController onCheckCoverageISPLocation address_info AAAAA===', address_info)
                if (result.data.addresses && result.data.addresses.length === 1) {
                    // setShowModal(true);
                    setAddressSelected(result.data.addresses[0]);
                    setAddressHome({
                        ...address_info,
                        ...result.data.addresses[0],
                    });
                    let locationAvaible = await checkLocationAvaibleOrder();
                    if (locationAvaible) {
                        setShowModal(true);
                    }
                } else if (result.data.addresses && result.data.addresses.length > 1) {
                    setShowListAddresses(true);
                } else {
                    setMessage({
                        show: true,
                        content: t('address_not_support')
                    });
                }
            }
        }
        catch (ex) {
            console.log("onCheckCoverrage exception===", ex);
        }
        setShowLoading(false);
    }

    const onSetAddressSelected = async (address) => {
        if (address) {
            setAddressSelected(address);
            
            setAddressHome({
                ...addressInfor,
                ...address,
            });
            setShowListAddresses(false);
            let locationAvaible = await checkLocationAvaibleOrder();
            
            if(locationAvaible && locationAvaible.isCheck){
                if (locationAvaible.building && locationAvaible.building.length > 0) {
                    setBuilding(locationAvaible.building)
                    setOpenModalBuilding(true);
                } else
                    setShowModal(true)
            }    
            
            setShowLoading(false);
        }
    }
    const onSetBuildingSelected = async (data) => {
        setAddressSelected({...addressSelected,building:data});
        setAddressHome({
            ...addressInfor,
            ...addressSelected,
            building:data
        });
        setOpenModalBuilding(false)
        setShowModal(true)
    }
    const onProcessCheckCoverage = async (type) => {
        console.log("ispLocation===", ispLocation);
        if (type === 0) {
            await onCheckCoverage();
        } else {
            await onCheckCoverageISPLocation();
        }
    }

    const checkLocationAvaibleOrder = async () => {
        setShowLoading(true)
        let isCheck = false;
        let building = []
        try {
            let addressSelected = getAddressHome();
            if (addressSelected) {
                let queryParams = {
                    locationId: addressSelected.premise_ref_isp,
                    openserve_ref_isp: addressSelected.openserve_ref_isp,
                } 
                if (addressSelected.product_types == 'OC') {
                    queryParams = {
                        uuid: addressSelected.premisesid,
                        lat: addressSelected.latitude,
                        lng: addressSelected.longitude,
                    }
                }
                if (addressSelected.metrofibre_ref_isp) {
                    queryParams.metrofibre_ref_isp = addressSelected.metrofibre_ref_isp;
                }
                let result = await wsclients.lab4services.checkLocationAvaibleOrderV3(queryParams);
                setShowLoading(false)
                console.log("checkLocationAvaibleOrder result: ", result);
                //hardcode
                // debugger;
                if (result.code === 'OK') {
                    //order vumatel
                    
                    // check building 
                    building = result.data && result.data.openserve_building_infos ? result.data.openserve_building_infos : [];

                    if (result.data && result.data.is_available_create_order) {
                        console.log("checkLocationAvaibleOrder result: ", result);
                        setAvailableVumaProducts();
                        isCheck = true;

                    }
                    if (result.data && result.data.is_available_create_order_metrofibre) {
                        setAvailableMetroFibreProducts();
                        isCheck = true;
                    }
                    if (result.data && result.data.is_availabe_create_openserve_order) {
                        console.log("checkLocationAvaibleOrder result: ", result);
                        // setOpenserveServices(result.data.openserve_services ? result.data.openserve_services : []);
                        let _openserveProducts = result.data.openserve_services ? result.data.openserve_services : [];
                        isCheck = onCheckProductsOpenserve(_openserveProducts);
                    }
                    // else if(result.data && !result.data.is_availabe_create_openserve_order)  {
                    //     let _packages = packages.openserve;
                    //     _packages.forEach(item => {
                    //         item.is_available = false;
                    //     });
                    //     setPackages(prevState => ({
                    //         ...prevState,
                    //         openserve: _packages,
                    //     }))
                    // }
                    if (result.data && result.data.octotel_services && result.data.octotel_services.length > 0) {
                        isCheck = checkProductsOctotel(result.data.octotel_services)
                    }
                    if (result.data && !result.data.is_availabe_create_openserve_order && !result.data.is_available_create_order && !result.data.is_available_create_order_metrofibre && addressSelected.product_types != 'OC') {
                        console.log("checkLocationAvaibleOrder result: ", result);
                        setMessage({
                            show: true,
                            content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                        });
                    }
                    // else if(result.data && result.data.is_availabe_create_openserve_order == null) {
                    //     setPackages(prevState => ({
                    //         ...prevState,
                    //         openserve: [],
                    //     }))
                    // }
                }
            }
        } catch (ex) {
            console.log("checkLocationAvaibleOrder exception: ", ex);
        }
        if (!isCheck) {
            setMessage({
                show: true,
                content: t('address_used')
            });
        }
        return { isCheck, building };
    }

    const onCheckProductsOpenserve = (openserveServices) => {
        let isCheck = false;
        try {
            let _openserveProducts = [];
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (openserveServices && openserveServices.length > 0 && packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflylites.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflysmarts.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        let isAvailable = false;

                        let existItems = openserveServices.filter(x => item.code.includes(x.ProductCode + '-'));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _openserveProducts.filter(x => item.code.includes(x.ProductCode + '-'));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OS'
                                });
                            } else {
                                _openserveProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OS'
                                });
                            }
                        } else {
                            _openserveProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }

                        _productflyultras.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OS'
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;
                console.log("AAAA onCheckProductsOpenserve new _packages:   ", _packages);

                console.log("AAAA onCheckProductsOpenserve _openserveProducts1111: ", packages);
                if (_openserveProducts && _openserveProducts.length > 0) {
                    isCheck = true;
                } else {
                    isCheck = false;
                }
                setPackages(_packages);
            }
        } catch (error) {
            console.log("AAAA onCheckProductsOpenserve error: ", error);
        }
        console.log("AAAA onCheckProductsOpenserve isCheck: ", isCheck)
        return isCheck;
    }

    const setAvailableVumaProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflylites.push({
                                ...item,
                                is_available: true,
                                product_type_code: item.product_type == 'vuma_reach' ? 'VR' : 'VC'
                            });
                        } else {
                            _productflylites.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflysmarts.push({
                                ...item,
                                is_available: true,
                                product_type_code: item.product_type == 'vuma_reach' ? 'VR' : 'VC'
                            });
                        } else {
                            _productflysmarts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        if (item.product_type != 'openserve') {
                            _productflyultras.push({
                                ...item,
                                is_available: true,
                                product_type_code: item.product_type == 'vuma_reach' ? 'VR' : 'VC'
                            });
                        } else {
                            _productflyultras.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OS'
                            });
                        }
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("setAvailableProducts error: ", error);
        }
    }

    const setAvailableMetroFibreProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflylites.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflylites.push(item)
                        }
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflysmarts.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflysmarts.push(item)
                        }
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        if (item.product_type == 'metrofibre') {
                            _productflyultras.push({
                                ...item,
                                is_available: true,
                                product_type_code: 'MF'
                            });
                        } else {
                            _productflyultras.push(item);
                        }
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("setAvailableProducts error: ", error);
        }
    }

    const resetAvailableProducts = () => {
        try {
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}

            if (packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        _productflylites.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        _productflysmarts.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        _productflyultras.push({
                            ...item,
                            is_available: false,
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;

                setPackages(_packages);
            }
        } catch (error) {
            console.log("resetAvailableProducts error: ", error);
        }
    }

    const getLetterFirstProduct = (name) => {
        let str = "OPENSERVE FIBRE CONNECT";
        let words = str.split(" ");
        let initials = words.map(word => word.charAt(0));
        console.log(initials.join(""));
        return initials.join("");
    }

    const checkProductsOctotel = (octotel_services) => {
        let isCheck = false;
        try {
            let _octotelProducts = [];
            let _productflylites = [];
            let _productflysmarts = [];
            let _productflyultras = [];
            let _packages = {}
            if (octotel_services && octotel_services.length > 0 && packages) {
                if (packages.productflylites) {
                    packages.productflylites.forEach(item => {
                        let isAvailable = false;

                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflylites.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                if (packages.productflysmarts) {
                    packages.productflysmarts.forEach(item => {
                        let isAvailable = false;

                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflysmarts.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                if (packages.productflyultras) {
                    packages.productflyultras.forEach(item => {
                        let isAvailable = false;
                        
                        let existItems = octotel_services.filter(x => item.code.includes(x.productCode));
                        if (existItems && existItems.length > 0) {
                            isAvailable = true;
                            let existPackage = _octotelProducts.filter(x => item.code.includes(x.productCode));
                            if (!existPackage || (existPackage && existPackage.length == 0)) {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: true,
                                    product_type_code: 'OC'
                                });
                            } else {
                                _octotelProducts.push({
                                    ...existItems[0],
                                    ...item,
                                    is_available: false,
                                    product_type_code: 'OC'
                                });
                            }
                        } else {
                            _octotelProducts.push({
                                ...item,
                                is_available: false,
                                product_type_code: 'OC'
                            });
                        }

                        _productflyultras.push({
                            ...item,
                            is_available: isAvailable,
                            product_type_code: 'OC'
                        });
                    })
                }

                _packages.productflylites = _productflylites;
                _packages.productflysmarts = _productflysmarts;
                _packages.productflyultras = _productflyultras;
                console.log("AAAA checkProductsOctotel new _packages:   ", _packages);

                console.log("AAAA checkProductsOctotel _octotelProducts: ", packages);
                if (_octotelProducts && _octotelProducts.length > 0) {
                    isCheck = true;
                } else {
                    isCheck = false;
                }
                setPackages(_packages);
            }
        } catch (error) {
            console.log("AAAA checkProductsOctotel error: ", error);
        }
        console.log("AAAA checkProductsOctotel isCheck: ", isCheck)
        return isCheck;
    }

    const { classes, language } = props;
    // console.log("addressSelected===", addressSelected);

    return (
        <>
            <LandingPageView
                language={language}
                classes={classes}
                packages={packages}
                address={address}
                choosePackage={choosePackage}
                showModal={showModal}
                showTerm={showTerm}
                showListAddresses={showListAddresses}
                addresses={addresses}
                addressSelected={addressSelected}
                searchType={searchType}
                ispLocation={ispLocation}
                openserveServices={openserveServices}
                addressInfor={addressInfor}
                onSelectPackage={onSelectPackage}
                onCheckCoverage={onProcessCheckCoverage}
                setAddress={setAddress}
                setChoosePackage={setChoosePackage}
                setShowModal={setShowModal}
                onShowTerm={onShowTerm}
                setAddressSelected={onSetAddressSelected}
                setShowListAddresses={setShowListAddresses}
                setSearchType={setSearchType}
                setISPLocation={setISPLocation}
                setAddressInfor={setAddressInfor}
                onCheckCoverageLatLongV3={onCheckCoverageLatLongV3}
                onCloseModalBuilding={() => setOpenModalBuilding(false)}
                openModalBuilding={openModalBuilding}
                building={building}
                onSetBuildingSelected={onSetBuildingSelected}
            />
            {showLoading && <CustomLoading
                open={showLoading}
                handleClose={() => setShowLoading(false)}
            />}
            {message && message.show && <CustomAlert
                open={message.show}
                title={message.title ? message.title : null}
                message={message.content ? message.content : null}
                isConfirm={message.isConfirm ? message.isConfirm : false}
                customMessage={message.customMessage ? message.customMessage : null}
                showButtonClose={true}
                onClose={() => setMessage({})}
                confirmAction={message.confirmAction ? message.confirmAction : null}
            />}
        </>
    )
}
